const CardsBlock = ({ items }) => {
  const featured = items.slice(0, 1).pop()
  const news = items.slice(1, items.length)
  return (
    <div className="mx-auto max-w-7xl py-20 px-4 sm:px-6 lg:px-8">
      <div className="space-y-12">
        <div className="grid lg:grid-cols-2 mt-4 lg:mt-0 bg-grey">
          <img
            className="object-cover h-[300px] sm:h-[400px] lg:h-full"
            src={featured.imagen.data.attributes.formats.large.url}
          ></img>
          <div className="w-full py-10 lg:py-24 text-left px-4 sm:px-8 lg:px-16">
            <h1 className="text-4xl font-alliance-medium tracking-tight text-blue lg:text-3xl xl:text-4xl lg:mr-24">
              <span className="block xl:inline">{featured.titulo}</span>
            </h1>
            <p className="mt-8 font-alliance max-w-md text-blue text-xl sm:text-lg md:mt-5 md:max-w-3xl"></p>
            <div className="mt-16">
              <div className="rounded-full inline-block">
                <a
                  href={featured.pdf.data.attributes.url}
                  className="flex items-center justify-center rounded-full border border-transparent text-base font-alliance-medium lg:min-w-[250px] bg-accent hover:bg-[#c9e300] text-blue px-16 py-4 md:py-6 md:px-10 text-[18px] lg:text-[24px]"
                >
                  Descarregar
                </a>
              </div>
            </div>
          </div>
        </div>
        <ul
          role="list"
          className="space-y-4 sm:grid sm:grid-cols-2 gap-x-4 gap-y-10 sm:space-y-0 lg:grid-cols-4 mt-5 mb-10"
        >
          {news.map((item, idx) => {
            return (
              <li key={idx}>
                <a className="group" href={item.pdf.data.attributes.url}>
                  <div className="aspect-w-3 aspect-h-3">
                    <img
                      className="object-cover"
                      src={item.imagen.data.attributes.formats.small.url}
                      alt=""
                    />
                    <div
                      className={`transition duration-300 ease-in-out group-hover:bg-blue opacity-80`}
                    ></div>
                    <div className="absolute justify-center items-center pointer-events-none hidden group-hover:flex">
                      <img
                        src="/assets/icons/download-white.svg"
                        alt=""
                        className="pointer-events-none object-fill w-12 ml-5"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col capitalize">
                    <div className="flex flex-1 flex-col justify-between">
                      <div className="flex-1">
                        <p className="mt-3 font-alliance-medium text-gray-900 capitalize text-xl">
                          {item.titulo}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default CardsBlock
